/** Rutas globales de la aplicación (sin prefijo de módulo). */
export const routePaths = {
  home: '/',
  login: '/login',
  accessPending: '/acceso-pendiente',
  accessDenied: '/acceso-denegado',
  notifications: '/notifications',
} as const;

/** Rutas del módulo admin (relativas al prefijo /admin). */
export const adminPaths = {
  users: 'usuarios',
  audit: 'auditoria',
} as const;

/** Rutas de inventario (configuración). */
export const modulePaths = {
  inventory: '/inventario',
  categories: '/categorias',
  customFields: '/campos',
  commercial: '/comercial',
  reservations: '/reservas',
  billing: '/facturacion',
  logistics: '/logistica',
  maintenance: '/mantenimiento',
  calendar: '/agenda',
  admin: '/admin',
} as const;

export type ModulePath = (typeof modulePaths)[keyof typeof modulePaths];
